import {Error404Page as BaseError404Page} from '@hconnect/uikit/src/lib2'
import {useTranslation} from 'react-i18next'
import {Link, useNavigate} from 'react-router'

import {FEATURE_NAMESPACE} from '../consts'

export const UnsupportedChecklistKindErrorPage = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const navigate = useNavigate()

  return (
    <BaseError404Page
      caption={t('unsupportedChecklistKindErrorPage.title')}
      description={t('unsupportedChecklistKindErrorPage.description')}
      onGoBack={() => navigate(-1)}
      RouterLink={Link}
    />
  )
}
